import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-144e12c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content",
  ref: "contentContainer"
};
const _hoisted_2 = {
  class: "bid-formula-block"
};
const _hoisted_3 = {
  class: "formula-container"
};
const _hoisted_4 = {
  class: "formula-left"
};
const _hoisted_5 = {
  class: "formula-right"
};
const _hoisted_6 = {
  class: "bidding-type"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_9 = {
  class: "activated-icons-container"
};
const _hoisted_10 = {
  key: 0,
  class: "activated-icon-box"
};
const _hoisted_11 = {
  key: 1,
  class: "activated-icon-box"
};
const _hoisted_12 = {
  key: 2,
  class: "activated-icon-box"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_14 = {
  class: "boost-button-popover-content"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SP (Product boost)", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SB (Campaign boost)", -1));
const _hoisted_17 = {
  class: "boost-button"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " <> ", -1));
const _hoisted_19 = {
  key: 0,
  class: "curved-container"
};
const _hoisted_20 = {
  class: "submit-panel"
};
const _hoisted_21 = {
  class: "buttons-div"
};
const _hoisted_22 = {
  key: 1,
  class: "curved-container history"
};
const _hoisted_23 = {
  class: "growth-ambition-block"
};
const _hoisted_24 = {
  class: "header-block-container"
};
const _hoisted_25 = {
  class: "header-container"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " Customer margin reinvestment level per targeting ", -1));
const _hoisted_27 = {
  class: "header-container scale-values"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " Scale all values proportionally ", -1));
const _hoisted_29 = {
  class: "container"
};
const _hoisted_30 = {
  class: "performance-container"
};
const _hoisted_31 = {
  class: "performance-targeting"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header purple"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title purple"
}, [/*#__PURE__*/_createElementVNode("span", null, "Performance Targeting")]), /*#__PURE__*/_createElementVNode("p", {
  class: "description purple"
}, [/*#__PURE__*/_createElementVNode("span", null, "Keywords and ASINs that have driven conversions")])], -1));
const _hoisted_33 = {
  class: "target blue"
};
const _hoisted_34 = {
  class: "icon"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title blue"
}, [/*#__PURE__*/_createElementVNode("span", null, "Non-branded keywords")]), /*#__PURE__*/_createElementVNode("p", {
  class: "description blue"
}, [/*#__PURE__*/_createElementVNode("span", null, "All high-performing keywords, excluding branded terms")])], -1));
const _hoisted_36 = {
  key: 0,
  class: "link"
};
const _hoisted_37 = {
  class: "link-icon-container"
};
const _hoisted_38 = {
  class: "target purple"
};
const _hoisted_39 = {
  class: "icon"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title purple"
}, [/*#__PURE__*/_createElementVNode("span", null, "Competitor’s products")]), /*#__PURE__*/_createElementVNode("p", {
  class: "description purple"
}, [/*#__PURE__*/_createElementVNode("span", null, "Target competitor product detail pages")])], -1));
const _hoisted_41 = {
  key: 1,
  class: "link"
};
const _hoisted_42 = {
  class: "link-icon-container"
};
const _hoisted_43 = {
  class: "target red"
};
const _hoisted_44 = {
  class: "icon"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title red"
}, [/*#__PURE__*/_createElementVNode("span", null, "Branded keywords & products")]), /*#__PURE__*/_createElementVNode("p", {
  class: "description red"
}, [/*#__PURE__*/_createElementVNode("span", null, "Target your brand's keywords and products")])], -1));
const _hoisted_46 = {
  key: 2,
  class: "link bottom"
};
const _hoisted_47 = {
  class: "link-icon-container"
};
const _hoisted_48 = {
  class: "discover-target"
};
const _hoisted_49 = {
  class: "icon"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", null, "Discovery targeting")]), /*#__PURE__*/_createElementVNode("p", {
  class: "description"
}, [/*#__PURE__*/_createElementVNode("span", null, "Exploration campaigns to surface new converting keywords")])], -1));
const _hoisted_51 = {
  class: "customer-value-block"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "customer-value-block-title"
}, " Customer value scope ", -1));
const _hoisted_53 = {
  key: 0,
  class: "bidding-type-toggle"
};
const _hoisted_54 = {
  class: "bidding-type-switch-wrapper"
};
const _hoisted_55 = {
  key: 1,
  class: "chart"
};
const _hoisted_56 = {
  class: "chart-wrapper"
};
const _hoisted_57 = {
  key: 2,
  class: "no-chart"
};
const _hoisted_58 = {
  class: "no-chart-content"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-chart-message"
}, " Lifetime Value (LTV) insights are only available for Seller accounts. You can continue using margin-based bidding strategies. ", -1));
const _hoisted_60 = {
  class: "timing-placement-block"
};
const _hoisted_61 = {
  class: "content-title"
};
const _hoisted_62 = {
  class: "timing-placement-charts"
};
const _hoisted_63 = {
  class: "strategic-layers-charts"
};
const _hoisted_64 = {
  class: "strategic-layers-chart-header"
};
const _hoisted_65 = {
  class: "strategic-layers-chart-header-icon-and-title"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-and-subtitle"
}, [/*#__PURE__*/_createTextVNode(" Hourly CVR "), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, " Bid more during high-converting hours ")], -1));
const _hoisted_67 = {
  key: 0,
  class: "amc-chart-wrapper"
};
const _hoisted_68 = {
  key: 1,
  class: "no-chart"
};
const _hoisted_69 = {
  class: "no-chart-content"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-chart-message"
}, " No data available ", -1));
const _hoisted_71 = {
  class: "strategic-layers-chart-header"
};
const _hoisted_72 = {
  class: "strategic-layers-chart-header-icon-and-title"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-and-subtitle"
}, [/*#__PURE__*/_createTextVNode(" Placement CVR "), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, " Bid more where shoppers convert better ")], -1));
const _hoisted_74 = {
  key: 0,
  class: "amc-chart-wrapper"
};
const _hoisted_75 = {
  key: 1,
  class: "no-chart"
};
const _hoisted_76 = {
  class: "no-chart-content"
};
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-chart-message"
}, " No data available ", -1));
const _hoisted_78 = {
  class: "strategic-layers-chart-header"
};
const _hoisted_79 = {
  class: "strategic-layers-chart-header-icon-and-title"
};
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-and-subtitle"
}, [/*#__PURE__*/_createTextVNode(" Seasonal CVR "), /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle"
}, " Adjust bids to monthly conversion trends ")], -1));
const _hoisted_81 = {
  key: 0,
  class: "amc-chart-wrapper"
};
const _hoisted_82 = {
  key: 1,
  class: "no-chart"
};
const _hoisted_83 = {
  class: "no-chart-content"
};
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-chart-message"
}, " No data available ", -1));
const _hoisted_85 = {
  class: "bid-simulation-content"
};
const _hoisted_86 = {
  class: "content-upper"
};
const _hoisted_87 = {
  class: "product-and-formula"
};
const _hoisted_88 = {
  class: "product"
};
const _hoisted_89 = {
  class: "product-title"
};
const _hoisted_90 = {
  class: "formula"
};
const _hoisted_91 = {
  class: "formula-left"
};
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "formula-item growth-ambition"
}, " Targeting intensity ", -1));
const _hoisted_93 = {
  class: "formula-item customer-value"
};
const _hoisted_94 = {
  class: "bidding-type"
};
const _hoisted_95 = {
  class: "formula-item timing-placement"
};
const _hoisted_96 = {
  class: "activated-icons-container"
};
const _hoisted_97 = {
  key: 0,
  class: "activated-icon-box"
};
const _hoisted_98 = {
  key: 1,
  class: "activated-icon-box"
};
const _hoisted_99 = {
  key: 2,
  class: "activated-icon-box"
};
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "formula-item product-boost"
}, " Product override ", -1));
const _hoisted_101 = {
  class: "formula-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TagIconNew = _resolveComponent("TagIconNew");
  const _component_EqualsIcon = _resolveComponent("EqualsIcon");
  const _component_b_button = _resolveComponent("b-button");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_CalendarIcon = _resolveComponent("CalendarIcon");
  const _component_BoxIcon = _resolveComponent("BoxIcon");
  const _component_ArrowUpRight = _resolveComponent("ArrowUpRight");
  const _component_CartIcon = _resolveComponent("CartIcon");
  const _component_CalculatorIcon = _resolveComponent("CalculatorIcon");
  const _component_clock_rewind_icon = _resolveComponent("clock-rewind-icon");
  const _component_app_checkbox = _resolveComponent("app-checkbox");
  const _component_ppc_bid_setting_input = _resolveComponent("ppc-bid-setting-input");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_link_icon = _resolveComponent("link-icon");
  const _component_app_switch = _resolveComponent("app-switch");
  const _component_Bar = _resolveComponent("Bar");
  const _component_alert_octagon = _resolveComponent("alert-octagon");
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_ppc_bid_settings_history_popover = _resolveComponent("ppc-bid-settings-history-popover");
  const _component_b_img = _resolveComponent("b-img");
  const _component_ppc_bid_simulator = _resolveComponent("ppc-bid-simulator");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_app_card_custom = _resolveComponent("app-card-custom");
  return _openBlock(), _createBlock(_component_app_card_custom, {
    "no-padding": "",
    style: {
      "height": "100%",
      "display": "block"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_TagIconNew), _createTextVNode(" Max Bid "), _createVNode(_component_EqualsIcon)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_wrap_with_popover, {
      width: "fit-content",
      class: "formula-button-popover"
    }, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString(!$data.activeFormulaTab['customer value'] ? 'Go to ' : 'Current ') + "section ", 1)]),
      default: _withCtx(() => [_createVNode(_component_b_button, {
        onClick: _cache[0] || (_cache[0] = $event => $options.changeActiveFormulaTab('customer value')),
        class: _normalizeClass(['formula-button customer-value', {
          active: $data.activeFormulaTab['customer value']
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(" Customer margin "), _createElementVNode("div", _hoisted_6, _toDisplayString({
          margin: 'First purchase',
          ltv: 'First + Repeat'
        }[_ctx.biddingType]), 1)]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    }), _hoisted_7, _createVNode(_component_wrap_with_popover, {
      width: "fit-content",
      triggers: "hover",
      class: "formula-button-popover"
    }, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString(!$data.activeFormulaTab['growth ambition'] ? 'Go to ' : 'Current ') + "section ", 1)]),
      default: _withCtx(() => [_createVNode(_component_b_button, {
        onClick: _cache[1] || (_cache[1] = $event => $options.changeActiveFormulaTab('growth ambition')),
        class: _normalizeClass(['formula-button growth-ambition', {
          active: $data.activeFormulaTab['growth ambition']
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(" Targeting intensity ")]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    }), _hoisted_8, _createVNode(_component_wrap_with_popover, {
      width: "fit-content",
      triggers: "hover",
      class: "formula-button-popover"
    }, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString(!$data.activeFormulaTab['timing and placement'] ? 'Go to ' : 'Current ') + "section ", 1)]),
      default: _withCtx(() => [_createVNode(_component_b_button, {
        onClick: _cache[2] || (_cache[2] = $event => $options.changeActiveFormulaTab('timing and placement')),
        class: _normalizeClass(['formula-button timing-placement', {
          active: $data.activeFormulaTab['timing and placement']
        }])
      }, {
        default: _withCtx(() => [_createTextVNode(" Timing & placement "), _createElementVNode("div", _hoisted_9, [$data.amcPlacementState ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_app_icon, {
          icon: "layout-bottom",
          size: 12,
          color: "#056B69"
        })])) : _createCommentVNode("", true), $data.amcSeasonalityState ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_CalendarIcon, {
          height: 12,
          width: 12,
          color: "#056B69"
        })])) : _createCommentVNode("", true), $data.amcHourlyState ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_app_icon, {
          icon: "clock",
          size: 12,
          color: "#056B69"
        })])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    }), _hoisted_13, _createVNode(_component_wrap_with_popover, {
      width: "fit-content",
      triggers: "hover",
      class: "formula-button-popover"
    }, {
      title: _withCtx(() => [_createTextVNode(" Redirect to campaign list ")]),
      default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
        click: "",
        placement: "bottom",
        customClass: "boost-button-popover",
        width: "fit-content"
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
          class: "content-item",
          onClick: _cache[3] || (_cache[3] = () => {
            _ctx.$emit('goToSPTab');
          })
        }, [_createVNode(_component_BoxIcon, {
          width: 16,
          height: 16
        }), _hoisted_15, _createVNode(_component_ArrowUpRight)]), _createElementVNode("div", {
          class: "content-item",
          onClick: _cache[4] || (_cache[4] = () => {
            _ctx.$emit('goToSBTab');
          })
        }, [_createVNode(_component_CartIcon, {
          width: 16,
          height: 16
        }), _hoisted_16, _createVNode(_component_ArrowUpRight)])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createTextVNode(" Campaign/Product overrides "), _createVNode(_component_app_icon, {
          icon: "chevron-down",
          size: 10,
          color: "#71777F"
        })])]),
        _: 1
      })]),
      _: 1
    }), _hoisted_18, _createVNode(_component_wrap_with_popover, {
      width: "fit-content",
      triggers: "hover",
      class: "formula-button-popover"
    }, {
      title: _withCtx(() => [_createTextVNode(" Bid efficiency is factored into your bid calculation automatically. Configuration customization is not available yet. ")]),
      default: _withCtx(() => [_createVNode(_component_b_button, {
        onClick: _cache[5] || (_cache[5] = () => {}),
        class: _normalizeClass(['formula-button cannibalization disabled'])
      }, {
        default: _withCtx(() => [_createTextVNode(" Bid efficiency ")]),
        _: 1
      })]),
      _: 1
    })])]), _createElementVNode("div", {
      class: "simulation-button",
      onClick: _cache[6] || (_cache[6] = () => {
        $data.bidSimulationModal = true;
      })
    }, [_createTextVNode(" Example "), _createVNode(_component_CalculatorIcon)])]), $data.isEdited.length ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
      class: _normalizeClass(["history-btn", [{
        pressed: $data.in_box_history_popover_shown
      }]]),
      id: "bid-setting-history-in-box"
    }, [_createVNode(_component_clock_rewind_icon), _createTextVNode(" History ")], 2), _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.setting_note = $event),
      placeholder: "Enter note (at least 10 characters) for saving this change",
      class: _normalizeClass(["note-input", {
        error: $data.setting_note.length < 10
      }])
    }, null, 2), [[_vModelText, $data.setting_note]]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
      class: "cancel-btn",
      onClick: _cache[8] || (_cache[8] = (...args) => $options.reverseAllValue && $options.reverseAllValue(...args))
    }, "Cancel"), _createElementVNode("div", {
      class: "submit-btn",
      onClick: _cache[9] || (_cache[9] = (...args) => $options.onSubmit && $options.onSubmit(...args))
    }, "Apply")])])])) : (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", {
      class: _normalizeClass(["history-button", [{
        pressed: $data.history_popover_shown
      }]]),
      id: "bid-setting-history"
    }, [_createVNode(_component_clock_rewind_icon), _createTextVNode(" History ")], 2)])), _withDirectives(_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_app_icon, {
      icon: "margin-reinvestment"
    }), _hoisted_26]), _createElementVNode("div", _hoisted_27, [_createVNode(_component_app_checkbox, {
      modelValue: $data.scale_proportionally,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.scale_proportionally = $event)
    }, null, 8, ["modelValue"]), _hoisted_28])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", {
      class: _normalizeClass(["body", [{
        scale_proportionally: $data.scale_proportionally
      }]])
    }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", {
      onClick: _cache[11] || (_cache[11] = $event => $options.onBlur($data.isChangingBidValue || 'non_branded_keyword_targeting')),
      class: "content-box"
    }, [_createElementVNode("div", _hoisted_34, [_createVNode(_component_app_icon, {
      icon: "bid-layout-alt",
      size: "16"
    })]), _hoisted_35]), _createElementVNode("div", {
      class: _normalizeClass(["btn-percentage", {
        'focus-blue': $data.isChangingBidValue == 'non_branded_keyword_targeting'
      }])
    }, [$options.isChangedValue('non_branded_keyword_targeting') ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "loading-bid-setting",
      onClick: _cache[12] || (_cache[12] = _withModifiers($event => $options.onReverseClick('non_branded_keyword_targeting'), ["prevent"]))
    })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_ppc_bid_setting_input, {
      modelValue: $data.displayedValues.non_branded_keyword_targeting,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.displayedValues.non_branded_keyword_targeting = $event),
      class: "percentage",
      refName: "non_branded_keyword_targeting",
      ref: "non_branded_keyword_targeting",
      isValid: $data.isValid.non_branded_keyword_targeting,
      "onUpdate:isValid": _cache[14] || (_cache[14] = $event => $data.isValid.non_branded_keyword_targeting = $event),
      onOnBlur: $options.onBlur
    }, null, 8, ["modelValue", "isValid", "onOnBlur"]), [[_vShow, $data.isChangingBidValue == 'non_branded_keyword_targeting']]), _withDirectives(_createElementVNode("span", null, "%", 512), [[_vShow, $data.isChangingBidValue == 'non_branded_keyword_targeting']]), $data.isChangingBidValue != 'non_branded_keyword_targeting' ? (_openBlock(), _createBlock(_component_percentage_value, {
      key: 1,
      value: $data.displayedValues.non_branded_keyword_targeting / 100,
      onClick: _cache[15] || (_cache[15] = $event => $options.onChangeBidValue('non_branded_keyword_targeting')),
      style: {
        "color": "#484c51"
      }
    }, null, 8, ["value"])) : _createCommentVNode("", true)], 2)]), $data.scale_proportionally ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createVNode(_component_link_icon)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
      onClick: _cache[16] || (_cache[16] = $event => $options.onBlur($data.isChangingBidValue || 'competitor_product_targeting')),
      class: "content-box"
    }, [_createElementVNode("div", _hoisted_39, [_createVNode(_component_app_icon, {
      icon: "bid-users-up",
      size: "16"
    })]), _hoisted_40]), _createElementVNode("div", {
      class: _normalizeClass(["btn-percentage", {
        'focus-purple': $data.isChangingBidValue == 'competitor_product_targeting'
      }])
    }, [$options.isChangedValue('competitor_product_targeting') ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "loading-bid-setting",
      onClick: _cache[17] || (_cache[17] = _withModifiers($event => $options.onReverseClick('competitor_product_targeting'), ["prevent"]))
    })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_ppc_bid_setting_input, {
      modelValue: $data.displayedValues.competitor_product_targeting,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $data.displayedValues.competitor_product_targeting = $event),
      class: "percentage",
      refName: "competitor_product_targeting",
      ref: "competitor_product_targeting",
      isValid: $data.isValid.competitor_product_targeting,
      "onUpdate:isValid": _cache[19] || (_cache[19] = $event => $data.isValid.competitor_product_targeting = $event),
      onOnBlur: $options.onBlur
    }, null, 8, ["modelValue", "isValid", "onOnBlur"]), [[_vShow, $data.isChangingBidValue == 'competitor_product_targeting']]), _withDirectives(_createElementVNode("span", null, "%", 512), [[_vShow, $data.isChangingBidValue == 'competitor_product_targeting']]), $data.isChangingBidValue != 'competitor_product_targeting' ? (_openBlock(), _createBlock(_component_percentage_value, {
      key: 1,
      value: $data.displayedValues.competitor_product_targeting / 100,
      onClick: _cache[20] || (_cache[20] = $event => $options.onChangeBidValue('competitor_product_targeting')),
      style: {
        "color": "#484c51"
      }
    }, null, 8, ["value"])) : _createCommentVNode("", true)], 2)]), $data.scale_proportionally ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createVNode(_component_link_icon)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", {
      onClick: _cache[21] || (_cache[21] = $event => $options.onBlur($data.isChangingBidValue || 'branded_keyword_product_targeting')),
      class: "content-box"
    }, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_app_icon, {
      icon: "bid-tag",
      size: "16"
    })]), _hoisted_45]), _createElementVNode("div", {
      class: _normalizeClass(["btn-percentage", {
        'focus-red': $data.isChangingBidValue == 'branded_keyword_product_targeting'
      }])
    }, [$options.isChangedValue('branded_keyword_product_targeting') ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "loading-bid-setting",
      onClick: _cache[22] || (_cache[22] = _withModifiers($event => $options.onReverseClick('branded_keyword_product_targeting'), ["prevent"]))
    })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_ppc_bid_setting_input, {
      modelValue: $data.displayedValues.branded_keyword_product_targeting,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.displayedValues.branded_keyword_product_targeting = $event),
      class: "percentage",
      refName: "branded_keyword_product_targeting",
      ref: "branded_keyword_product_targeting",
      isValid: $data.isValid.branded_keyword_product_targeting,
      "onUpdate:isValid": _cache[24] || (_cache[24] = $event => $data.isValid.branded_keyword_product_targeting = $event),
      onOnBlur: $options.onBlur
    }, null, 8, ["modelValue", "isValid", "onOnBlur"]), [[_vShow, $data.isChangingBidValue == 'branded_keyword_product_targeting']]), _withDirectives(_createElementVNode("span", null, "%", 512), [[_vShow, $data.isChangingBidValue == 'branded_keyword_product_targeting']]), $data.isChangingBidValue != 'branded_keyword_product_targeting' ? (_openBlock(), _createBlock(_component_percentage_value, {
      key: 1,
      value: $data.displayedValues.branded_keyword_product_targeting / 100,
      onClick: _cache[25] || (_cache[25] = $event => $options.onChangeBidValue('branded_keyword_product_targeting')),
      style: {
        "color": "#484c51"
      }
    }, null, 8, ["value"])) : _createCommentVNode("", true)], 2)]), $data.scale_proportionally ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createVNode(_component_link_icon)])])) : _createCommentVNode("", true)], 2)]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", {
      onClick: _cache[26] || (_cache[26] = $event => $options.onBlur($data.isChangingBidValue || 'discovery_targeting')),
      class: "content-box"
    }, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_app_icon, {
      icon: "search-refactor",
      size: "16"
    })]), _hoisted_50]), _createElementVNode("div", {
      class: _normalizeClass(["btn-percentage", {
        'focus-gray': $data.isChangingBidValue == 'discovery_targeting'
      }])
    }, [$options.isChangedValue('discovery_targeting') ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "loading-bid-setting",
      onClick: _cache[27] || (_cache[27] = _withModifiers($event => $options.onReverseClick('discovery_targeting'), ["prevent"]))
    })) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_ppc_bid_setting_input, {
      modelValue: $data.displayedValues.discovery_targeting,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.displayedValues.discovery_targeting = $event),
      class: "percentage",
      refName: "discovery_targeting",
      ref: "discovery_targeting",
      isValid: $data.isValid.discovery_targeting,
      "onUpdate:isValid": _cache[29] || (_cache[29] = $event => $data.isValid.discovery_targeting = $event),
      onOnBlur: $options.onBlur
    }, null, 8, ["modelValue", "isValid", "onOnBlur"]), [[_vShow, $data.isChangingBidValue == 'discovery_targeting']]), _withDirectives(_createElementVNode("span", null, "%", 512), [[_vShow, $data.isChangingBidValue == 'discovery_targeting']]), $data.isChangingBidValue != 'discovery_targeting' ? (_openBlock(), _createBlock(_component_percentage_value, {
      key: 1,
      value: $data.displayedValues.discovery_targeting / 100,
      onClick: _cache[30] || (_cache[30] = $event => $options.onChangeBidValue('discovery_targeting')),
      style: {
        "color": "#484c51"
      }
    }, null, 8, ["value"])) : _createCommentVNode("", true)], 2)])])])], 512), [[_vShow, $data.activeFormulaTab['growth ambition']]]), _withDirectives(_createElementVNode("div", _hoisted_51, [_hoisted_52, $options.isSellerCentralAccount ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", {
      class: _normalizeClass(["bidding-type-label", {
        active: _ctx.biddingType === 'margin'
      }])
    }, "First purchase only", 2), _createVNode(_component_app_switch, {
      "model-value": _ctx.biddingType,
      "onUpdate:modelValue": $options.onBiddingTypeChange,
      options: $data.biddingTypes,
      between: "",
      class: "bidding-type-switch"
    }, null, 8, ["model-value", "onUpdate:modelValue", "options"]), _createElementVNode("span", {
      class: _normalizeClass(["bidding-type-label", {
        active: _ctx.biddingType === 'ltv'
      }])
    }, "First + repeat purchases", 2)])])) : _createCommentVNode("", true), $options.isSellerCentralAccount ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createVNode(_component_Bar, {
      data: $options.ltvChartData,
      options: $options.ltvChartOptions
    }, null, 8, ["data", "options"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createVNode(_component_alert_octagon, {
      color: "#3C3939",
      width: 16
    }), _hoisted_59])]))], 512), [[_vShow, $data.activeFormulaTab['customer value']]]), _withDirectives(_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createVNode(_component_app_icon, {
      icon: "ai",
      size: 16,
      color: "#4C8EFF"
    }), _createTextVNode(" Adjust bids based on conversion patterns ")]), _createElementVNode("div", _hoisted_62, [_createVNode(_component_navigation_tabs, {
      tabs: $data.strategicLayersTabs,
      modelValue: $options.strategicLayersTab,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $options.strategicLayersTab = $event)
    }, null, 8, ["tabs", "modelValue"]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", {
      class: _normalizeClass(["strategic-layers-chart", {
        active: $data.amcHourlyState,
        no_data: !$data.hourlyAmcData.length
      }]),
      style: {
        "max-width": "50%"
      }
    }, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createVNode(_component_app_icon, {
      icon: "clock",
      color: "#71777F"
    }), _hoisted_66]), _createVNode(_component_app_switch, {
      "model-value": $data.hourlyAmcData.length ? $data.amcHourlyState : false,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = val => $options.onAmcToggleChange('hourly', val)),
      simple: "",
      class: "amc-state-switch",
      disabled: !$data.hourlyAmcData.length
    }, null, 8, ["model-value", "disabled"])]), $data.hourlyAmcData.length ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createVNode(_component_Bar, {
      data: $options.hourlyAmcChartData,
      options: $options.hourlyAmcChartOptions
    }, null, 8, ["data", "options"])])) : (_openBlock(), _createElementBlock("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createVNode(_component_alert_octagon, {
      color: "#3C3939",
      width: 16
    }), _hoisted_70])]))], 2), _createElementVNode("div", {
      class: _normalizeClass(["strategic-layers-chart", {
        active: $data.amcPlacementState,
        no_data: !$data.placementAmcData.length
      }])
    }, [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createVNode(_component_app_icon, {
      icon: "layout-bottom",
      size: 16,
      color: "#757575"
    }), _hoisted_73]), _createVNode(_component_app_switch, {
      "model-value": $data.amcPlacementState,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = val => $options.onAmcToggleChange('placement', val)),
      simple: "",
      class: "amc-state-switch",
      disabled: !$data.placementAmcData.length
    }, null, 8, ["model-value", "disabled"])]), $data.placementAmcData.length ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createVNode(_component_Bar, {
      data: $options.placementAmcChartData,
      options: $options.placementAmcChartOptions
    }, null, 8, ["data", "options"])])) : (_openBlock(), _createElementBlock("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createVNode(_component_alert_octagon, {
      color: "#3C3939",
      width: 16
    }), _hoisted_77])]))], 2), _createElementVNode("div", {
      class: _normalizeClass(["strategic-layers-chart", {
        active: $data.amcSeasonalityState,
        no_data: true
      }])
    }, [_createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createVNode(_component_CalendarIcon, {
      height: 16,
      width: 16,
      color: "#71777F"
    }), _hoisted_80]), _createVNode(_component_app_switch, {
      "model-value": $data.amcSeasonalityState,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = val => $options.onAmcToggleChange('seasonality', val)),
      simple: "",
      class: "amc-state-switch",
      disabled: ""
    }, null, 8, ["model-value"])]), $data.seasonalAmcData.length ? (_openBlock(), _createElementBlock("div", _hoisted_81, [_createVNode(_component_Bar, {
      data: $options.seasonalAmcChartData,
      options: $options.seasonalAmcChartOptions
    }, null, 8, ["data", "options"])])) : (_openBlock(), _createElementBlock("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createVNode(_component_alert_octagon, {
      color: "#3C3939",
      width: 16
    }), _hoisted_84])]))], 2)])])], 512), [[_vShow, $data.activeFormulaTab['timing and placement']]]), $data.isEdited.length ? (_openBlock(), _createBlock(_component_ppc_bid_settings_history_popover, {
      key: 2,
      target: "bid-setting-history-in-box",
      historical_settings: $data.historical_settings,
      onClose: _cache[35] || (_cache[35] = $event => $options.onCloseBidSettingHistory('bid-setting-history-in-box')),
      onShown: _cache[36] || (_cache[36] = () => {
        $data.in_box_history_popover_shown = true;
      }),
      onHidden: _cache[37] || (_cache[37] = () => {
        $data.in_box_history_popover_shown = false;
      })
    }, null, 8, ["historical_settings"])) : (_openBlock(), _createBlock(_component_ppc_bid_settings_history_popover, {
      key: 3,
      target: "bid-setting-history",
      historical_settings: $data.historical_settings,
      onClose: _cache[38] || (_cache[38] = $event => $options.onCloseBidSettingHistory('bid-setting-history')),
      onShown: _cache[39] || (_cache[39] = () => {
        $data.history_popover_shown = true;
      }),
      onHidden: _cache[40] || (_cache[40] = () => {
        $data.history_popover_shown = false;
      })
    }, null, 8, ["historical_settings"])), _createVNode(_component_app_modal, {
      modelValue: $data.bidSimulationModal,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => $data.bidSimulationModal = $event),
      title: "Bid simulation",
      noOk: "",
      noCancel: "",
      noFooter: "",
      custom_class: `bid-simulation-modal ${$data.bidSimulationModal ? 'flex-display' : ''}`
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, [_createTextVNode(" Example of bids placed on a sponsored product "), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createVNode(_component_b_img, {
        src: $options.ppcBidSimulatorCampaignGroupImage,
        alt: "Image",
        class: "product-image"
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_89, _toDisplayString($options.ppcBidSimulatorCampaignGroupName), 1)]), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_hoisted_92, _createVNode(_component_app_icon, {
        icon: "cross",
        color: "#ADADAD",
        size: 12
      }), _createElementVNode("div", _hoisted_93, [_createTextVNode(" Customer margin "), _createElementVNode("div", _hoisted_94, _toDisplayString({
        margin: 'First purchase',
        ltv: 'First + Repeat'
      }[_ctx.biddingType]), 1)]), _createVNode(_component_app_icon, {
        icon: "cross",
        color: "#ADADAD",
        size: 12
      }), _createElementVNode("div", _hoisted_95, [_createTextVNode(" Timing & Placement "), _createElementVNode("div", _hoisted_96, [$data.amcPlacementState ? (_openBlock(), _createElementBlock("div", _hoisted_97, [_createVNode(_component_app_icon, {
        icon: "layout-bottom",
        size: 12,
        color: "#056B69"
      })])) : _createCommentVNode("", true), $data.amcSeasonalityState ? (_openBlock(), _createElementBlock("div", _hoisted_98, [_createVNode(_component_CalendarIcon, {
        height: 12,
        width: 12,
        color: "#056B69"
      })])) : _createCommentVNode("", true), $data.amcHourlyState ? (_openBlock(), _createElementBlock("div", _hoisted_99, [_createVNode(_component_app_icon, {
        icon: "clock",
        size: 12,
        color: "#056B69"
      })])) : _createCommentVNode("", true)])]), _createVNode(_component_app_icon, {
        icon: "cross",
        color: "#ADADAD",
        size: 12
      }), _hoisted_100]), _createElementVNode("div", _hoisted_101, [_createVNode(_component_EqualsIcon, {
        width: 16,
        height: 16,
        color: "#595959"
      }), _createTextVNode(" Computed Max Bid ")])])]), _createVNode(_component_ppc_bid_simulator, {
        targeting: $data.displayedValues,
        currency: $props.currency
      }, null, 8, ["targeting", "currency"])])])]),
      _: 1
    }, 8, ["modelValue", "custom_class"])], 512)]),
    _: 1
  });
}